export class OwnerMailingAddressRawDto {
  address1: string;
  address2: string;
  city: string;
  stateCode: string;
  postalCode: string;
  countryCode: string;
  sameAsPropertyAddress: boolean;
  isValid: boolean;
}
